export const labellingCasesEnum = {
  TITLE_CASE: 'TITLE_CASE',
  CAMEL_CASE: 'CAMEL_CASE',
  SNAKE_CASE: 'SNAKE_CASE',
} as const

export type LabellingCasesEnum = (typeof labellingCasesEnum)[keyof typeof labellingCasesEnum]

export type LabellingCases = LabellingCasesEnum